const allowedRedirectHttpsHosts = new Set([
  'app.notablehealth.com',
  'app.notablehealth-staging.com',
  'app.notable.engineering',
  'notablehealth-staging.com',
]);
const allowedRedirectHttpsHostSuffixes = ['.ephemeral.staging.notable.engineering'];

export function isValidRedirect(redirect: string): boolean {
  let redirectUrl;
  try {
    redirectUrl = new URL(redirect);
  } catch (e) {
    return false;
  }

  if (redirectUrl.hostname !== window.location.hostname) {
    return false;
  }

  // Allow redirecting to localhost only for development
  if (
    import.meta.env.DEV &&
    (redirectUrl.hostname === 'localhost' ||
      redirectUrl.hostname === '127.0.0.1' ||
      redirectUrl.hostname.endsWith('.localhost'))
  ) {
    return true;
  }

  if (
    allowedRedirectHttpsHosts.has(redirectUrl.hostname) ||
    allowedRedirectHttpsHostSuffixes.some((suffix) => redirectUrl.hostname.endsWith(suffix))
  ) {
    return redirectUrl.protocol === 'https:';
  }

  return false;
}

export function setLoginRedirect(url: string) {
  if (isValidRedirect(url)) {
    localStorage.setItem('loginRedirect', url);
  }
}

export function popLoginRedirect(): string | null {
  const storedRedirect = localStorage.getItem('loginRedirect');
  localStorage.removeItem('loginRedirect');
  return storedRedirect;
}

const loginEmailKey = 'staff:loginEmail';
export function setLoginEmail(email: string | undefined) {
  if (email) {
    localStorage.setItem(loginEmailKey, email);
  } else {
    localStorage.removeItem(loginEmailKey);
  }
}

export function getLoginEmail() {
  return localStorage.getItem(loginEmailKey);
}
